export default function (value, suffix) {
    return value.substr(-suffix.length) === suffix;
}
//# sourceMappingURL=endsWith.js.map